import { EvaButtonModule } from './../eva-button/eva-button.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OffersComponent } from './offers/offers.component';
import { OfferCardComponent } from './offer-card/offer-card.component';
import { TagTextModule } from '../tag-text/tag-text.module';
import { TranslateModule } from '@ngx-translate/core';
import { SliderModule } from '@shopping-angular-components/slider';
import { MainTitleModule } from '../main-title/main-title.module';
import { TitleCardComponent } from './title-card/title-card.component';
import { OfferCardInfoComponent } from "./offer-card-info/offer-card-info.component";
import { ClustersComponent } from "./clusters/clusters.component";
import { ClusterComponent } from "./cluster/cluster.component";
import { TextModule } from "../text/text.module";
import { SelectableDatesComponent } from './dates-popup/selectable-dates.component';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { FlightItemComponent, HotelItemComponent, TourItemComponent, OfferCardDetailInfoComponent } from './offer-card-detail-info/offer-card-detail-info.component';
import { BaggagesWrapperModule } from './baggages-wrapper/baggages-wrapper.module';
import { MediaPictureGalleryModule } from '@shopping-angular-components/media-picture-gallery';
import { LoaderModule } from '@shopping-angular-components/loader';
import { ModalModule } from '@shopping-angular-components/modal';
import { LoyaltyOfferInfoComponent } from "./loyalty-offer-info/loyalty-offer-info.component";
import { LoyaltyModule } from '@shopping-angular-components/loyalty';
import { LoyaltyService } from '@shopping-angular-components/loyalty';
import { LoyaltySwitchComponent } from "./loyalty-switch/loyalty-switch.component";
import { DualPromoModule } from './dual-promo/dual-promo.module';
import { ReplaceParamsPipe } from "../../pipes/replace-params.pipe";
import { OfferCardPriceboxComponent } from './offer-card-pricebox/offer-card-pricebox.component';
import { ClusterPriceboxComponent } from './cluster-pricebox/cluster-pricebox.component';
import { ReviewScoreModule } from '../review-score/review-score.module';
import { ReviewTotalCommentsModule } from '../review-total-comments/review-total-comments.module';
import { OutstandingDriverComponent } from './outstanding-driver/outstanding-driver.component';

import { OfferCardSelectorComponent } from './offer-card-selector/offer-card-selector.component';
import { OfferDriversComponent } from './offer-drivers/offer-drivers.component';
import { CommonOfferCardComponent } from './offer-card-selector/common-offer-card/common-offer-card.component';
import { ReducedOfferCardComponent } from './offer-card-selector/reduced-offer-card/reduced-offer-card.component';
import { DetailedOfferCardComponent } from './offer-card-selector/detailed-offer-card/detailed-offer-card.component';
import { JustDatesOfferCardComponent } from './offer-card-selector/just-dates-offer-card/just-dates-offer-card.component';
import { OfferImageComponent } from './offer-image/offer-image.component';
import { WowOfferCardComponent } from './offer-card-selector/wow-offer-card/wow-offer-card.component';
import { OfferMultipleImageComponent } from './offer-multiple-image/offer-multiple-image.component';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { OffersButtonItemComponent } from './offers/offers-button-item.component';
import { TooltipModule } from '@shopping-angular-components/tooltip';
import { FormModule } from '../form/form.module';
import { DistributionPassengersContentModalComponent } from './distribution-passengers-content-modal/distribution-passengers-content-modal.component';
import { OfferRibbonComponent } from './offer-ribbon/offer-ribbon.component';
import { PriceboxWithChildComponent } from './pricebox-with-child/pricebox-with-child.component';
import { PriceboxModule } from './pricebox.module';
import { UserFavoritesModule } from '../user-favorites/user-favorites.module';
import { BasicOfferCardComponent } from './offer-card-selector/basic-offer-card/basic-offer-card.component';
import { SimplifiedOfferCardComponent } from './offer-card-selector/simplified-offer-card/simplified-offer-card.component';
import { BreakLinePipe } from 'projects/common/pipes/break-line.pipe';
import { ListOfferCardComponent } from './offer-card-selector/list-offer-card/list-offer-card.component';
import { RankingNumberComponent } from './offer-card-selector/ranking-number/ranking-number.component';
import { OptionalLinkModule } from '../optional-link/optional-link.module';
@NgModule({
  declarations: [
    OffersComponent,
    OfferCardComponent,
    OfferCardInfoComponent,
    OfferCardDetailInfoComponent,
    OfferCardPriceboxComponent,
    TitleCardComponent,
    ClustersComponent,
    ClusterComponent,
    ClusterPriceboxComponent,
    SelectableDatesComponent,
    HotelItemComponent,
    FlightItemComponent,
    TourItemComponent,
    LoyaltyOfferInfoComponent,
    LoyaltySwitchComponent,
    ReplaceParamsPipe,
    BreakLinePipe,
    OfferCardSelectorComponent,
    OfferDriversComponent,
    OutstandingDriverComponent,
    CommonOfferCardComponent,
    ReducedOfferCardComponent,
    JustDatesOfferCardComponent,
    SimplifiedOfferCardComponent,
    DetailedOfferCardComponent,
    OfferImageComponent,
    WowOfferCardComponent,
    OfferRibbonComponent,
    OfferMultipleImageComponent,
    OffersButtonItemComponent,
    PriceboxWithChildComponent,
    DistributionPassengersContentModalComponent,
    BasicOfferCardComponent,
    ListOfferCardComponent,
    RankingNumberComponent
  ],
  imports: [
    CommonModule,
    TagTextModule,
    TextModule,
    TranslateModule,
    SliderModule,
    MainTitleModule,
    EvaButtonModule,
    BaggagesWrapperModule,
    MediaPictureGalleryModule,
    LoaderModule,
    LoyaltyModule,
    ModalModule,
    DualPromoModule,
    ReviewScoreModule,
    ReviewTotalCommentsModule,
    TooltipModule,
    SliderProModule,
    FormModule,
    PriceboxModule,
    UserFavoritesModule,
    OptionalLinkModule
  ],
  exports: [
    OffersComponent,
    ClustersComponent,
    LoyaltySwitchComponent,
    OfferCardSelectorComponent,
    OfferImageComponent,
    SimplifiedOfferCardComponent,
  ],
  providers: [
    LandingModelService,
    LoyaltyService,
    ReplaceParamsPipe,
    BreakLinePipe,
  ]
})
export class OffersModule { }
